(function ($) {
    var _tenantChangeModal = new app.ModalManager({
        viewUrl: abp.appPath + "Account/TenantChangeModal",
        scriptUrls: abp.appPath + "view-resources/Views/Shared/Components/TenantChange/_ChangeModal.min.js",
        modalClass: "TenantChangeModal",
        modalSize: null
    });

    $(".tenant-change-component a")
        .click(function (e) {
            e.preventDefault();
            _tenantChangeModal.open();
        });
})(jQuery);
